import * as React from 'react';

import { FormattedHTMLMessage } from 'js/lib/coursera.react-intl';

import Notification from 'bundles/notification-center/components/Notification';
import type {
  DiscussionForumNewAnswerForQuestionCreatorNotification as DiscussionForumNewAnswerForQuestionCreatorNotificationType,
  Notification as NotificationType,
} from 'bundles/notification-center/types';

import _t from 'i18n!nls/notification-center';

type Props = {
  notification: DiscussionForumNewAnswerForQuestionCreatorNotificationType;
  rank?: number;
  onClick: (notification: NotificationType) => void;
};

const DiscussionForumNewAnswerForQuestionCreatorNotification: React.FC<Props> = ({
  notification,
  rank,
  onClick,
  notification: {
    data: { course, redirectUrlOnClick },
  },
}) => (
  <Notification onClick={onClick} href={redirectUrlOnClick} notification={notification} rank={rank}>
    <FormattedHTMLMessage
      message={_t(`Somebody replied to your thread in {courseName}`)}
      courseName={course.name}
      tagName="span"
    />
  </Notification>
);

export default DiscussionForumNewAnswerForQuestionCreatorNotification;
